<template>
  <v-dialog v-model="dialog" max-width="1000">
    <v-card
      :prepend-icon="contextIcon"
      :title="contextTitle"
      style="border-radius: 0px"
    >
      <v-card-text>
        <v-alert
          v-if="contractInfo"
          color="#ffb500"
          variant="tonal"
          type="info"
          class="mb-4"
        >
          <strong>{{ contractInfo.name }}</strong>
          <br />
          {{ $t("start-date") }}: {{ formatDate(contractInfo.startDate) }} |
          {{ $t("end-date") }}: {{ formatDate(contractInfo.endDate) }}
          <br />
          <strong>{{ $t("remaining-points-contract") }}:</strong>
          {{
            totalPoints === 0 || totalPoints < 0
              ? 0
              : Math.ceil(totalPoints).toLocaleString("fr-FR")
          }}
          {{ $t("points") }}
        </v-alert>
        <first-carousel-item :contractInfo="contractInfo"></first-carousel-item>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          :text="$t('close')"
          variant="plain"
          @click="$emit('close')"
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiAccount, mdiFileDocumentOutline } from "@mdi/js";
import FirstCarouselItem from "../FirstCarouselItem.vue";

export default {
  name: "ShowStatsCustomerAdmin",
  props: {
    modelDialog: {
      type: Boolean,
      required: true,
    },
    context: {
      type: String,
      default: "customer",
      validator: (value) => ["customer", "contract"].includes(value),
    },
    contractInfo: {
      type: Object,
      default: null,
    },
  },
  components: { FirstCarouselItem },
  data() {
    return {
      mdiAccount,
      mdiFileDocumentOutline,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelDialog;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    /**
     * Total des points du contrat/client
     */
    totalPoints() {
      const stats = this.$store.state.statsCustomer.statsCustomer;
      if (!stats) return 0;
      return stats.totalPoints || 0;
    },
    /**
     * Icône en fonction du contexte
     */
    contextIcon() {
      return this.context === "contract"
        ? this.mdiFileDocumentOutline
        : this.mdiAccount;
    },
    /**
     * Titre en fonction du contexte
     */
    contextTitle() {
      if (this.context === "contract") {
        return this.$t("admin.stats-contract") || "Statistiques du contrat";
      }
      return this.$t("admin.stats-customer");
    },
  },
  methods: {
    /**
     * Formate une date au format local
     */
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString();
    },
  },
};
</script>
